module.exports = __webpack_public_path__ + "static/media/report3.a274f763.png";